import { useTheme } from 'styled-components'
import { useMediaQuery } from 'usehooks-ts'

import { breakpoints } from '@/config/layout'
import { useServer } from '@/modules/healthblocks/ServerProvider'
import { Logo } from '@/modules/shared/components/logo'
import {
  LoginLayoutContainer,
  LoginLayoutContent,
  LoginLayoutImage,
  LoginLayoutImageContainer,
  LoginLayoutLogo,
  StLogo,
  StLogosBanner,
} from './LoginLayout.styled'

import type { ReactNode } from 'react'

type LoginLayoutProps = {
  children?: ReactNode
  image: string
  imagePosition?: string
}

const LoginLayout = ({ children, image, imagePosition }: LoginLayoutProps) => {
  const isMobile = useMediaQuery(breakpoints.toS)
  const server = useServer()
  const theme = useTheme()

  return (
    <LoginLayoutContainer>
      <LoginLayoutContent>{children}</LoginLayoutContent>

      <LoginLayoutImageContainer>
        {isMobile ? (
          <LoginLayoutLogo>
            <Logo />
          </LoginLayoutLogo>
        ) : null}
        <LoginLayoutImage src={image} imagePosition={imagePosition} />
      </LoginLayoutImageContainer>

      {isMobile && server?.logo && (
        <StLogosBanner gap={theme.UI.Spacing.Space4}>
          <StLogo src={server.logo} alt={`Logo van ${server.display}`} />
        </StLogosBanner>
      )}
    </LoginLayoutContainer>
  )
}

export { LoginLayout }
